import { LuArrowRight } from "react-icons/lu";
import { IdentityChip } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/states/components/verifyChrome";
import { VerifyButton } from "@/pages/quiz/base/questions/sumsubAttachmentBlock/states/components/verifyButton";

interface IProps {
  onContinue: () => void;
}

// Shown after too many failed verify attempts — hands the user off to the
// Sumsub photo-ID + selfie flow.
const HandoffState = ({ onContinue }: IProps) => {
  return (
    <>
      <IdentityChip />

      <h1 className="mb-3 text-[28px] font-semibold leading-tight text-[#2c2150] sm:text-3xl">
        Let’s verify another way
      </h1>

      <p className="mb-6 text-[15px] leading-[1.5] text-[#303030]">
        We still couldn’t verify your identity automatically. To finish your
        order, continue with a government-issued photo ID and a quick selfie.
      </p>

      <VerifyButton
        label="Continue"
        iconRight={<LuArrowRight size={20} />}
        onClick={onContinue}
      />
    </>
  );
};

export { HandoffState };
